import { render } from "./ViewLogin.vue?vue&type=template&id=c057c9ce"
import script from "./ViewLogin.vue?vue&type=script&lang=js"
export * from "./ViewLogin.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__